import createEnum from 'scripts/lib/create_enum';

const InteractionType = createEnum(
  'CHAT',
  'CONVERSATION',
  'CONVERSATION_NOTE',
  'CREDIT_CARD_REQUEST',
  'EMAIL',
  'EXTERNAL_FORM',
  'FB_MESSAGE',
  'INSTAGRAM_DIRECT',
  'PHONE_CALL',
  'PHONE_CALLBACK',
  'SMS',
  'TASK',
  'TASK_EDIT',
  'TWITTER',
  'WHATSAPP'
);

export default InteractionType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/composition/interaction_type.js